import { ConstantsService } from 'app/services/constants-service';

/**
 * Shared display date/time formatters for the Trust UI.
 * Display standards: dd MMM yyyy / dd MMM yyyy h:mm a
 * Do not use for API payloads or form picker values (use ISO yyyy-MM-dd).
 */

function toDate(value: any): Date | null {
  if (value == null || value === '') {
    return null;
  }
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'number') {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) {
      return null;
    }
    // Prefer date-only parsing as local calendar date to avoid UTC day shift
    const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
    if (dateOnly) {
      const d = new Date(+dateOnly[1], +dateOnly[2] - 1, +dateOnly[3]);
      return isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(trimmed);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
}

function pad2(n: number): string {
  return n < 10 ? '0' + n : String(n);
}

/**
 * Format a value as dd MMM yyyy (e.g. 16 Jul 2026).
 */
export function formatDisplayDate(value: any): string {
  const d = toDate(value);
  if (!d) {
    return '';
  }
  const day = pad2(d.getDate());
  const month = ConstantsService.MONTH_NAMES[d.getMonth()];
  return day + ' ' + month + ' ' + d.getFullYear();
}

/**
 * Format a value as dd MMM yyyy h:mm a (e.g. 16 Jul 2026 8:08 PM).
 */
export function formatDisplayDateTime(value: any): string {
  const d = toDate(value);
  if (!d) {
    return '';
  }
  const datePart = formatDisplayDate(d);
  let hours = d.getHours();
  const minutes = pad2(d.getMinutes());
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  if (hours === 0) {
    hours = 12;
  }
  return datePart + ' ' + hours + ':' + minutes + ' ' + ampm;
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/date-format.util.ts